export { webVitalsPlugin as plugin, webVitalsPlugin } from './web-vitals-plugin';
export { VERSION } from './version';
